export default `
# Introduction

Welcome to the **PostaMail Platform API** documentation. The API allows you to interact programmatically with PostaMail Web.
This documentation describes how to integrate applications with PostaMail Web to send legal postal communications and retrieve their return information.

## Base URL

All requests go through the platform's reverse proxy under \`/api\`:

\`\`\`text
https://<your-postamail-domain>/api/<service>/<resource>
\`\`\`

## Environments

| Environment | Base URL |
|-------------|----------|
| PRE (pre-production) | \`https://pre-aws.postamail.es/api\` |
| PRO (production) | \`https://web.postamail.es/api\` |

> ⚠️ **Warning:** Any test, integration validation, load check or development trial must be performed against PRE (\`pre-aws.postamail.es\`). PRO (\`web.postamail.es\`) must only be used for production traffic.
> **PRE availability:** The PRE environment, reserved exclusively for testing, is available Monday to Friday from 08:00 to 20:00. Its availability may vary depending on circumstances.

For example, the Outbox service (shipments and drafts) is reachable at
\`/api/outbox/...\` and the Auth service at \`/api/auth/...\`.

## Request & response format

- Request bodies are JSON (\`Content-Type: application/json\`), except for endpoints that accept file uploads, which use \`multipart/form-data\`.
- Responses are JSON. Successful responses return the requested resource or an empty body for actions with no content to return.
- Errors are returned as plain text prefixed with an error code, see [Errors](/docs/api/errors).

## Getting started

1. [Authenticate](/docs/api/authentication) to obtain a session.
2. Call the API for the resource you need (see **API Reference** in the sidebar).
3. Handle [errors](/docs/api/errors) and expired sessions.
`



// WEBPACK FOOTER //
// ./src/components/docs/api/content/introduction.js